import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_PRODUCT, EDIT_PRODUCT, UPDATE_PRODUCT_PRICE } from './constants';

export const getProduct = extendRoutine(createRoutine(GET_PRODUCT), 'RESET');
export const editProduct = extendRoutine(createRoutine(EDIT_PRODUCT), 'RESET');
export const updateProductPrice = extendRoutine(createRoutine(UPDATE_PRODUCT_PRICE), 'RESET');
